function noop() {
    // NOTE: Intentionally do nothing
}


/**
 * Define loggers for vue instances
 */
export function createLogger(target, { levels, threshold, prefixFn, prefixLocation, filter }, vm) {
    const loglevel = levels.findIndex(({ fn }) => fn === threshold);

    return levels.reduce((acc, level) => {
        return Object.defineProperty(acc, level.fn, {
            get() {
                if (!filter(level, vm) || levels.findIndex(l => l) < loglevel) {
                    return noop;
                }

                const location = typeof prefixLocation === 'function' ? prefixLocation(vm) : prefixLocation;
                const prefix = typeof prefixFn === 'function' ? prefixFn(level, location, vm) : [prefixFn];

                return window.console[level.fn].bind(window.console, ...prefix);
            },
        });
    }, target);
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/plugins/vue-log/create-logger.js